import React, { useEffect, useMemo, useState } from 'react'
import UserService from '../../services/user/UserService'
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import Zonasi from '../../utilities/Zonasi'
import { FaDownload } from 'react-icons/fa'

const UpiRegModal = ({ showUpiRegModal, handleCloseUpiRegModal, upiId }) => {

    let userService = useMemo(() => new UserService(), [])

    const columns = [
        {
            name: 'Nomor Register',
            cell: row => row['upiRegNo']
        },
        {
            name: 'Tanggal Register',
            cell: row => row['upiRegTgl']
        },
        {
            name: 'Negara',
            cell: row => row['upiRegNeg']
        },
        {
            name: 'Zonasi',
            cell: row => <Zonasi id={row['upiRegZonasi']}/>
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Pilih</Tooltip>}>

                            <Button size="sm" variant="primary" onClick={() => pilihDataUpiReg(row)}>
                                <FaDownload /> Pilih
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            )
        }
    ]

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const pilihDataUpiReg = (row) => {
        handleCloseUpiRegModal(row)
    }

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const resUpiReg = await userService.listUpiReg(null, upiId, 0, 10)
                setListData(resUpiReg.data.data)
                setTotalData(resUpiReg.data.totalData)
                setLoading(false)
            } catch (error) {
                setListData([])
            }
        }
        fetchAllData()
    }, [userService, upiId])

    const handleChangePage = async (page) => {
        setLoading(true)
        const resUpiReg = await userService.listUpiReg(null, upiId, page - 1, size)
        setListData(resUpiReg.data.data)
        setTotalData(resUpiReg.data.totalData)
        setLoading(false)
    }

    const handlePerRowsChange = async (size, page) => {
        setLoading(true)
        const _res = await userService.listUpiReg(null, upiId, page - 1, size)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }

    return (
        <>
            <Modal
                show={showUpiRegModal}
                onHide={handleCloseUpiRegModal}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header>
                    <h6>Pilih Data Register UPI</h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive border-bottom my-3">
                        {loading && <Spinner />}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listData}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={totalData}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            persistTableHead={true}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpiRegModal